import { InstaApp } from 'components/InstaApp';
import { SmartBanner } from 'components/SmartBanner';
import { useQrRequest } from 'src/apiClient';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { useRouter } from 'next/router';
import { TableTagNamespace, TableTagMode } from 'src/shared/enums';

import SVGIcon from '../public/svg/background.svg';
import { createUrlForAndroid } from '../utils/utils';
import { getUrlForRestaurantMenu } from '../../src/utils';

import type { OS, Uuid } from 'src/shared/types';
import type { APIv1Qr } from 'src/shared-interface/ApiQrInterface';

export type DetailEndpoint<Path extends '/restaurant/by-id/:restaurantId' | '/restaurant/by-table-tag/:id/:namespace' | '/restaurant/by-eshop-order/:id' = '/restaurant/by-id/:restaurantId' | '/restaurant/by-table-tag/:id/:namespace' | '/restaurant/by-eshop-order/:id'> = {
    path: Path;
    queryParams: APIv1Qr['GET'][Path]['params'];
};

export const Detail = ({ os, isBrowserSafari, namespace, tableId, endpoint }: { os: OS; isBrowserSafari: boolean; namespace: TableTagNamespace; tableId?: string; endpoint: DetailEndpoint }) => {
    const { isInitialLoading: isLoading, data: response } = useQrRequest('GET', endpoint.path, [endpoint.path, ...Object.values(endpoint.queryParams)], {
        queryParams: endpoint.queryParams,
    });
    const router = useRouter();
    let component = <>Something went wrong on ~qr page.</>;

    if (response?.httpStatus === 200 &&
        response.result.restaurant.isTablePairedToRestaurant === true &&
        response.result.restaurant.isTagPairedToTable === false &&
        response.result.restaurant.tableTagMode !== TableTagMode.DIRECT_BILL &&
        namespace === TableTagNamespace.TABLE
    ) {
        // redirect to restaurant menu
        router.push(getUrlForRestaurantMenu(response.result.restaurant.id as Uuid));
    }

    if (response?.httpStatus === 200 && response.result.restaurant.id !== null) {
        if (os === 'android') {
            const tableTag = tableId ? { id: tableId, namespace, restaurantId: response.result.restaurant.id, restaurantName: response.result.restaurant.restaurantName || '' } : undefined;

            component = (
                <>
                    {/* INSTA_APP on android is triggered by click on button */}
                    <InstaApp
                        restaurantName={response.result.restaurant.restaurantName || ''}
                        urlPayByQerkoApp={createUrlForAndroid(tableTag).storeUrl}
                        urlRestaurantBackground={response.result.restaurant.restaurantImage}
                        urlRestaurantBackgroundPlaceholder={SVGIcon.src}
                        urlRestaurantLogo={response.result.restaurant.restaurantLogo}
                    />
                </>
            );
        } else if (os === 'ios') {
            component = (
                <>
                    {/* AppClip and SmartBanner is triggered by meta tag in html > head */}
                    <SmartBanner isBrowserSafari={isBrowserSafari} os={os} />
                </>
            );
        } else {
            // redirect to restaurant menu
            router.push(getUrlForRestaurantMenu(response.result.restaurant.id));
        }
    }

    if (response?.httpStatus === 404) {
        component = (
            <>Restaurant Id or Table Id was not found.</>
        );
    }

    return (
        <FullScreenLoader
            componentOrShow={isLoading ? false : (component)}
        />
    );
};
